// extracted by mini-css-extract-plugin
export var typingIndicator = "_sk-0";